import firebase from "firebase";
import "firebase/firestore";

export default {
  namespaced: true,
  state: {
    job: {},
    groupJob: {},
    groupJobs: [],
    groupJobMember: [],
    myJobs: [],
    otherUserJobs: [],
    groupJobRecords: [],
  },
  mutations: {
    addGroupJob(state: any, { groupJob }: { groupJob: any }) {
      if (groupJob.jobStatus !== 9) state.groupJobs.push(groupJob);
    },
    addMyJob(state: any, { myJob, memberList }: { myJob: any; memberList: any }) {
      myJob.memberList = memberList;
      if (myJob.jobStatus !== 9) state.myJobs.push(myJob);
    },
    addOtherUserJob(state: any, { otherUserJob, memberList }: any) {
      otherUserJob.memberList = memberList;
      const jobPublishingSetting = otherUserJob.jobPublishingSetting;
      if (otherUserJob.jobStatus !== 9 && (!jobPublishingSetting || jobPublishingSetting === 1 )) {
        state.otherUserJobs.push(otherUserJob);
      }
    },
    updateMyJob(state: any, job: any) {
      const index = state.myJobs.findIndex(
        (myJob: any) => myJob.jobId === job.jobId
      );
      state.myJobs[index] = job;
    },
    deleteMyJob(state: any, job: any) {
      const index = state.myJobs.findIndex(
        (myJob: any) => myJob.jobId === job.jobId
      );
      state.myJobs.splice(index, 1);
    },
    addTheJob(state: any, { job, memberList }: { job: any; memberList: any }) {
      job.memberList = memberList;
      state.job = job;
    },
    addTheGroupJob(state: any, groupJob: any) {
      state.groupJob = groupJob;
    },
    addGroupJobMember(state: any, {user, userJob, recordList,}: { user: any; userJob: any; recordList: any }) {
      const groupJobMember = {
        userId: user.userId,
        userName: user.userName,
        jobId: userJob.jobId,
        jobContinueCount: userJob.jobContinueCount,
        isAuthorized: userJob.isAuthorized,
        recordList: recordList,
      };
      state.groupJobMember.push(groupJobMember);
    },
    deleteGroupJobMember(state: any, userId: any) {
      const index = state.groupJobMember.findIndex(
        (member: any) => member.userId === userId
      );
      state.groupJobMember.splice(index, 1);
    },
    resetGroupJobMember(state: any) {
      state.groupJobMember = [];
    },
    resetGroupJobs(state: any) {
      state.groupJobs = [];
    },
    resetMyJobs(state: any) {
      state.myJobs = [];
    },
    resetOtherUserJobs(state: any) {
      state.otherUserJobs = [];
    },
    recordJob(state: any, record: any) {
      const index = state.myJobs.findIndex((i: any) => i.jobId == record.jobId);
      state.myJobs[index].jobContinueCount += 1;
    },
  },
  actions: {
    addMyJob({ commit, rootGetters }: { commit: any; rootGetters: any }, job: any) {
      const db = firebase.firestore();
      const userId = rootGetters.loginUserId;
      const groupId = rootGetters.group.groupId;
      // 個人ジョブの場合はユーザーIDをフィールドに追加する
      !job.groupId ? (job.userId = userId) : (job.userId = null);
      job.imagePath ="https://www.newsweekjapan.jp/stories/assets_c/2018/11/convictbook181105-top-thumb-720xauto-145462.jpg";
      // 取得したカテゴリーが未登録の場合はIDを発行してオブジェクトとしてセットし直す
      const categoryCollection = db.collection("categories");
      job.categoryList.forEach((category: any, index: number, array: any) => {
        if (typeof category == "string") {
          const categoryId = categoryCollection.doc().id;
          const newCategory = { id: categoryId, name: category };
          categoryCollection.doc(categoryId).set(newCategory);
          array.splice(index, 1, newCategory);
        }
      });
      // DB処理
      const addJobBatch = db.batch();
      const jobCollection = db.collection("jobs");
      const userCollection = db.collection("users");
      const groupCollection = db.collection("groups");
      const jobId = jobCollection.doc().id;
      const jobMember = { userId: userId };
      const user = {
        userId: userId,
        jobContinueCount: 0,
        jobId: jobId,
        isAuthorized: true,
      };
      const groupJob = { jobId: jobId };
      const memberList = [user];
      job.jobId = jobId;
      addJobBatch.set(jobCollection.doc(jobId), job);
      addJobBatch.set(jobCollection.doc(jobId).collection("members").doc(userId),jobMember);
      addJobBatch.set(userCollection.doc(userId).collection("jobs").doc(jobId),user);
      // groups>groupId>Jobs>jobId.{jobId: jobId}
      if (job.groupId) addJobBatch.set(groupCollection.doc(groupId).collection("jobs").doc(jobId),groupJob);
      addJobBatch.commit().then(() => {
        commit("addGroupJob", { groupJob: job });
        commit("addMyJob", { myJob: job, memberList: memberList });
      });
    },
    updateMyJob({ commit }: { commit: any }, job: any) {
      const db = firebase.firestore();
      // 取得したカテゴリーが未登録の場合はIDを発行してオブジェクトとしてセットし直す
      if (job.categoryList) {
        const categoryCollection = db.collection("categories");
        job.categoryList.forEach((category: any, index: number, array: any) => {
          if (typeof category == "string") {
            const categoryId = categoryCollection.doc().id;
            const newCategory = { id: categoryId, name: category };
            categoryCollection.doc(categoryId).set(newCategory);
            array.splice(index, 1, newCategory);
          }
        });
      }
      db.collection("jobs").doc(job.jobId).update(job).then(() => {
          job.jobStatus == 9 ? commit("deleteMyJob", job) : commit("updateMyJob", job);
      });
    },
    deleteGroupJob({ commit, rootGetters }: { commit: any; rootGetters: any }, groupJob: any) {
      const db = firebase.firestore();
      const jobId = groupJob.jobId;
      const userId = rootGetters.loginUserId;
      const deleteGroupJobBatch = db.batch();
      deleteGroupJobBatch.delete(db.collection(`users/${userId}/jobs`).doc(jobId));
      deleteGroupJobBatch.update(db.collection(`jobs`).doc(jobId), {jobStatus: 9});
      deleteGroupJobBatch.commit().then(() => {
        commit("deleteMyJob", groupJob);
      });
    },
    fetchGroupJobs({commit}: {commit: any }, groupId: any){
      commit("resetGroupJobs");
      const db = firebase.firestore();
      // const groupId = rootGetters.group.groupId
      const groupJobIdSnaps = db.collection(`groups/${groupId}/jobs`).get();
      groupJobIdSnaps.then((snapshot) => snapshot.forEach(doc => {
        db.collection(`jobs`).doc(doc.id).get().then((doc) => {
          commit("addGroupJob", { groupJob: doc.data() });
        });
      }));
    },
    fetchMyJobs({ commit }: any, user: any) {
      // 一旦stateを空にする
      commit("resetMyJobs");
      const db = firebase.firestore();
      const userId = user.uid;
      // usersコレクションの中のジョブID一覧を取得する
      db.collection(`users/${userId}/jobs`).get().then(snapshot => snapshot.forEach(doc => {
        //各ジョブIDに紐づくジョブ情報を取得する
        db.collection(`jobs`).doc(doc.id).get().then(jobDoc => {
          const myJob = jobDoc.data();
          const jobId = doc.id;
          const memberList: any = [];
          // ジョブIDを元にメンバー情報を取得する
          db.collection(`jobs/${jobId}/members`).get().then(snapshot => snapshot.forEach(memberDoc => {
            const userId = memberDoc.data().userId;
            // 取得したジョブメンバーのIDを元にメンバーが持つジョブ情報を取得する
            db.collection(`users/${userId}/jobs`).doc(jobId).get().then(userJobDoc => {
              const userJobData = userJobDoc.data();
              memberList.push(userJobData);
            });
          }));
          commit("addMyJob", {myJob: myJob, memberList: memberList});
        });
      }));
    },
    fetchOtherUserJobs({ commit }: any, userId: string) {
      // 一旦stateを空にする
      commit("resetOtherUserJobs");
      const db = firebase.firestore();
      // ユーザーに紐づくジョブ一覧を取得する
      const promise = db.collection(`users/${userId}/jobs`).get().then((snapshot) => snapshot.forEach((doc) => {
        //各ジョブIDに紐づくジョブ情報を取得する
        db.collection(`jobs`).doc(doc.id).get().then((jobDoc) => {
          const otherUserJob = jobDoc.data();
          const jobId = doc.id;
          const memberList: any = [];
          // ジョブIDを元にメンバー情報を取得する
          db.collection(`jobs/${jobId}/members`).get().then((snapshot) => snapshot.forEach((memberDoc) => {
            const userId = memberDoc.data().userId;
            // 取得したジョブメンバーのIDを元にメンバーが持つジョブ情報を取得する
            db.collection(`users/${userId}/jobs`).doc(jobId).get().then((userJobDoc) => {
              const userJobData = userJobDoc.data();
              memberList.push(userJobData);
            });
          }));
          commit("addOtherUserJob", { otherUserJob: otherUserJob, memberList: memberList,});
        });
      }));
      return Promise.resolve(promise);
    },
    fetchTheJob({ commit }: { commit: any }, jobId: any) {
      const db = firebase.firestore();
      db.collection("jobs").doc(jobId).get().then((jobDoc: any) => {
        db.collection(`jobs/${jobId}/members`).get().then(snapshot => snapshot.forEach(memberDoc => {
          const userId = memberDoc.data().userId;
          const memberList: any = [];
          db.collection(`users/${userId}/jobs`).doc(jobId).get().then(userJobDoc => {
            memberList.push(userJobDoc.data());
            commit("addTheJob", {job: jobDoc.data(), memberList: memberList,});
          });
        }));
      });
    },
    fetchTheGroupJob({ commit }: { commit: any }, jobId: any) {
      const db = firebase.firestore();
      db.collection("jobs").doc(jobId).get().then((doc) => commit("addTheGroupJob", doc.data()));
    },
    fetchGroupJobMember({ commit }: { commit: any }, jobId: any) {
      // 一旦stateを空にする
      commit("resetGroupJobMember");
      const db = firebase.firestore();
      // ジョブIDを元にメンバー情報を取得する
      db.collection(`jobs/${jobId}/members`).get().then(snapshot => snapshot.forEach(doc => {
        const userId = doc.data().userId;
        // 取得したジョブメンバーのIDとジョブIDからレコード情報を取得する
        const recordList: any = [];
        db.collection(`records`).where("jobId", "==", jobId).where("userId", "==", userId).get().then(snapshot => {
          snapshot.forEach(recordDoc => recordList.push(recordDoc.data()));
        });
        // 取得したジョブメンバーのIDを元にユーザー情報を取得する
        db.collection(`users`).doc(userId).get().then(userDoc => {
          db.collection(`users/${userId}/jobs`).doc(jobId).get().then(userJobDoc => {
            commit("addGroupJobMember", {user: userDoc.data(), userJob: userJobDoc.data(), recordList: recordList});
          });
        });
      }));
    },
    joinGroupJob({ commit, rootGetters }: { commit: any; rootGetters: any }, groupJob: any) {
      const db = firebase.firestore();
      const jobId = groupJob.jobId;
      const userId = rootGetters.loginUserId;
      const user = { userId: userId, userName: rootGetters.loginUserName };
      const userJob = {
        userId: userId,
        jobContinueCount: 0,
        jobId: jobId,
        isAuthorized: false,
      };
      const jobMember = { userId: userId };
      const memberList = [userJob];
      // DB処理
      const joinGroupJobBatch = db.batch();
      joinGroupJobBatch.set(db.collection(`jobs/${jobId}/members`).doc(userId), jobMember);
      joinGroupJobBatch.set(db.collection(`users/${userId}/jobs`).doc(jobId), userJob);
      joinGroupJobBatch.commit().then(() => {
        commit("addMyJob", { myJob: groupJob, memberList: memberList });
        commit("addGroupJobMember", {user: user, userJob: userJob, recordList: []});
      });
    },
    leaveGroupJob({ commit, rootGetters }: { commit: any; rootGetters: any }, groupJob: any) {
      const db = firebase.firestore();
      const userId = rootGetters.loginUserId;
      const jobId = groupJob.jobId;
      const leaveGroupJobBatch = db.batch();
      leaveGroupJobBatch.delete(db.collection(`users/${userId}/jobs`).doc(jobId));
      leaveGroupJobBatch.delete(db.collection(`jobs/${jobId}/members`).doc(userId));
      leaveGroupJobBatch.commit().then(() => {
        // stateのmyJobとjobMemberを整理
        commit("deleteMyJob", groupJob);
        commit("deleteGroupJobMember", userId);
      });
    },
    //今日のジョブの実施を記録する
    recordJob({ commit }: any, { record, job, userJobContinueCount, userInfo,}: 
      { record: any; job: any; userJobContinueCount: number; userInfo: any }) {
      const db = firebase.firestore();
      const recordJobBatch = db.batch();
      const usersCollection = db.collection("users");
      const recordsCollection = db.collection("records");
      const jobsCollection = db.collection("jobs");
      const recordId = recordsCollection.doc().id;
      const userId = userInfo.userId;
      const jobId = job.jobId;
      const userAchievementPower = userInfo.userAchievementPower;
      record.recordId = recordId;
      // 新規レコードを登録
      recordJobBatch.set(recordsCollection.doc(recordId), record);
      // 継続回数を加算
      recordJobBatch.update(usersCollection.doc(userId).collection("jobs").doc(jobId), { jobContinueCount: userJobContinueCount });
      // 達成力を加算
      recordJobBatch.update(usersCollection.doc(userId), { userAchievementPower: userAchievementPower });
      // ジョブ情報を更新
      !job.groupId ? recordJobBatch.update(jobsCollection.doc(jobId), { scheduledDate: job.scheduledDate, jobStatus: job.jobStatus })
                   : recordJobBatch.update(jobsCollection.doc(jobId), { jobStatus: job.jobStatus });
      // DB処理を実行
      recordJobBatch.commit().then(() => {
        // stateのジョブ情報を更新（メンバーリスト含む）
        commit("updateMyJob", job);
      });
    },
  },
  getters: {
    job: (state: any) => (state.job ? state.job : ""),
    groupJob: (state: any) => (state.groupJob ? state.groupJob : ""),
    groupJobs: (state: any) => (state.groupJobs ? state.groupJobs : ""),
    groupJobMember: (state: any) =>
      state.groupJobMember ? state.groupJobMember : "",
    myJobs: (state: any) => (state.myJobs ? state.myJobs : ""),
    otherUserJobs: (state: any) => state.otherUserJobs ? state.otherUserJobs : "",
    groupJobRecords: (state: any) =>
      state.groupJobRecords ? state.groupJobRecords : "",
  },
};
